import React from 'react';
 
class DownloadLink extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        return (
            <a className="pr-3" href={process.env.PUBLIC_URL+this.props.path}>
                {this.props.name} 
            </a>
      );
    }
}

export default DownloadLink;